module.exports = __webpack_public_path__ + "static/media/programari.c36b01b6.png";